import {DESKTOP_BREAKPOINT, TABLET_BREAKPOINT} from '../../common/scripts/constants';

export default {

    /**
     * Проверяет нужно ли показывать панель вместо баллуна;
     * @return {boolean} true/false - true - нужно/false нет
     */
    needBalloonPanel() {
        return window.innerWidth < TABLET_BREAKPOINT;
    },

    /**
     * Проверяет мобилка ли сейчас или нет
     * @return {boolean} true/false - мобилка/десктоп
     */
    isMobile() {
        return window.innerWidth < DESKTOP_BREAKPOINT;
    }
};

